import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const GearSpecState = Immutable.fromJS({
	gearSpec: {
		specId: '',
		specName: '',
		gearName: '',
		sModelNo: '',
		specFile: '',
		gearAliasName: '',
		modelDisplayName: ''
	},
	gearSpecValidation: {
		specId: {
			validationState: null,
			helpBlock: null
		},
		specName: {
			validationState: null,
			helpBlock: null
		},
		gearName: {
			validationState: null,
			helpBlock: null
		},
		sModelNo: {
			validationState: null,
			helpBlock: null
		},
		specFile: {
			validationState: null,
			helpBlock: null
		}
	},
	alertStyle: null,
	alertMessage: null,
	showModal: false,
	forInsert: true,
	allModelNos: []
});

const gearSpecReducer = handleActions({
	CHANGE_GEARSPEC_VALUE: (state, { payload }) => {
		let gearSpec = state.get('gearSpec');
		return state.merge({
			gearSpec: gearSpec.set(payload.id, payload.value),
		})
	},
	FORM_SUBMIT_GEARSPEC: (state, { payload }) => {
		return state.merge({
			gearSpec: payload.data.bean,
			gearSpecValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	OPEN_GEARSPEC_MODAL: (state, { payload }) => {
		return state.merge({
			forInsert: payload.forInsert,
			showModal: true
		})
	},
	CLOSE_GEARSPEC_MODAL: (state, { payload }) => {
		return state.merge({
			gearSpec: {
				specId: '',
				specName: '',
				gearName: '',
				modelNo: '',
				specFile: '',
				gearAliasName: '',
				modelDisplayName: ''
			},
			gearSpecValidation: {
				specId: {
					validationState: null,
					helpBlock: null
				},
				specName: {
					validationState: null,
					helpBlock: null
				},
				gearName: {
					validationState: null,
					helpBlock: null
				},
				modelNo: {
					validationState: null,
					helpBlock: null
				},
				specFile: {
					validationState: null,
					helpBlock: null
				}
			},
			alertStyle: null,
			alertMessage: null,
			showModal: false,
			forInsert: true
		})
	},
	FIND_GEARSPEC: (state, { payload }) => {
		return state.merge({
			gearSpec: payload.data
		})
	},
	FIND_ALL_MODELNOS: (state, { payload }) => {
		return state.merge({
			allModelNos: payload.data
		})
	},
}, GearSpecState);

export default gearSpecReducer;


// WEBPACK FOOTER //
// ./src/reducers/gearSpecReducer.js